import axios from "axios";
import React, { useState } from "react";
import FormModal from "../../../components/common/FormModal";
import Controls from "../../../components/controls/Controls";
import SubtitleSelect from "../../../components/controls/SubtitleSelect";
import { getPartner } from "../../../utils/partnerUtils";
import { formLabel } from "../../../styles/common";

export const STATUS_OPTIONS = [
  { 
    value: "ACTIVATE", 
    title: "Activate", 
    displayValue: "Activate",
    icon: () => <div style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#4CAF50' }} />
  },
  { 
    value: "SUSPEND", 
    title: "Suspend", 
    displayValue: "Suspend",
    icon: () => <div style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#FF9800' }} />
  },
];

export const STATUS_ACTION = {
  "ACTIVE" : "ACTIVATE",
  "SUSPENDED": "SUSPEND",
  "DELETED" : "SUSPEND"
};

export const REASON_OPTIONS = {
  ACTIVATE: [
    { value: "Merchant requested reactivation", title: "Merchant requested reactivation", displayValue: "Merchant requested reactivation" },
    { value: "Issue resolved", title: "Issue resolved", displayValue: "Issue resolved" },
    { value: "KYC completed", title: "KYC completed", displayValue: "KYC completed" },
    { value: "Manual Reactivation", title: "Manual Reactivation", displayValue: "Manual Reactivation" },
    { value: "Other", title: "Other", displayValue: "Other" },
  ],
  SUSPEND: [
    { value: "Violation of Terms", title: "Violation of Terms", displayValue: "Violation of Terms" },
    { value: "Fake Products", title: "Fake Products", displayValue: "Fake Products" },
    { value: "Abusive Content", title: "Abusive Content", displayValue: "Abusive Content" },
    { value: "Trademark Infringement", title: "Trademark Infringement", displayValue: "Trademark Infringement" },
    { value: "Phishing Site", title: "Phishing Site", displayValue: "Phishing Site" },
    { value: "Scam or Fraud", title: "Scam or Fraud", displayValue: "Scam or Fraud" },
    { value: "Other", title: "Other", displayValue: "Other" },
  ],
};

const StatusModal = ({ storeId, record, onSave, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);

  const initState = {
    action: { value: record.status ? STATUS_ACTION[record.status] : "", error: false },
    reason: { value: record.reason ?? "", error: false },
    notes: { value: record.notes ?? "", error: false },
  };

  const [formState, setFormState] = useState(initState);

  const onFormFieldChange = (fieldName, fieldValue) => {
    setFormState((prev) => ({
      ...prev,
      [fieldName]: { value: fieldValue, error: false },
    }));

    if (fieldName === "status") {
      setFormState((prev) => ({
        ...prev,
        reason: { value: "", error: false },
      }));
    }
  };

  const setFieldsError = (fields) => {
    setFormState((prev) => {
      const updated = { ...prev };
      fields.forEach((fld) => {
        updated[fld].error = true;
      });
      return updated;
    });
  };

  const validateForm = () => {
    let errorFlds = [];
    if (!formState.action.value) errorFlds.push("action");
    if (!formState.reason.value) errorFlds.push("reason");
    if (formState.notes.value && formState.notes.value.length > 128) errorFlds.push("notes");
    return errorFlds;
  };

  const updateStatus = async () => {
    let accessToken = localStorage.getItem("access_token");
    let partner = getPartner();
    let data = {
      action: formState.action.value,
      reason: formState.reason.value,
    };

    if (formState.notes.value.trim()) {
      data.notes = formState.notes.value;
    }

    let response = await axios.post(
      `${process.env.REACT_APP_API}/api/v1/partner/${partner.partner_slug}/shoopy-stores/${storeId}/status`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data.payload;
  };

  return (
    <FormModal
      heading="Store Action"
      open={open}
      onClose={() => {
        setOpen(false);
        onClose();
      }}
      onSave={async () => {
        let errorFlds = validateForm();
        if (errorFlds.length > 0) {
          setFieldsError(errorFlds);
          return;
        }
        setLoading(true);
        try {
          let upStore = await updateStatus();
          setLoading(false);
          setOpen(false);
          onSave(upStore);
        } catch (error) {
          setLoading(false);
          console.error("Error updating status:", error);
        }
      }}
      loading={loading}
          >
                 <div style={{ maxHeight: "400px", overflowY: "auto", paddingRight: "8px", position: "relative", zIndex: 1 }}>
           <SubtitleSelect
             optionList={STATUS_OPTIONS}
             value={formState.action.value}
             onChange={(val) => onFormFieldChange("action", val)}
             label="Action"
             error={formState.action.error ? "Select Action" : ""}
             labelPlacement="top"
             labelClass={formLabel}
             wrapperStyle={{ marginBottom: "24px", position: "relative", zIndex: 3 }}
           />

           <SubtitleSelect
             optionList={REASON_OPTIONS[formState.action.value] || []}
             value={formState.reason.value}
             onChange={(val) => onFormFieldChange("reason", val)}
             label="Reason"
             error={formState.reason.error ? "Select Reason" : ""}
             labelPlacement="top"
             disabled={!formState.action.value}
             labelClass={formLabel}
             wrapperStyle={{ marginBottom: "24px", position: "relative", zIndex: 2 }}
           />

           <Controls.Input
             type="text"
             name="notes"
             label="Notes (Optional)"
             value={formState.notes.value}
             onChange={(e) => onFormFieldChange(e.target.name, e.target.value)}
             error={formState.notes.error ? "Notes must be 128 characters or less" : ""}
             labelPlacement="top"
             inputProps={{ maxLength: 128 }}
             helperText={`${formState.notes.value.length}/128 characters`}
           />
         </div>
    </FormModal>
  );
};

export default StatusModal;
